import {defineCustomElement} from 'extensions/ui-utils';
import {html, LitElement} from 'lit';
import stylesheet from './x-room-progress.scss?as=stylesheet';

export class RoomProgress extends LitElement {
	static get styles () {
		return [stylesheet];
	}

	static get properties () {
		return {
			label: {
				type: String
			},
			max: {
				type: Number
			},
			min: {
				type: Number
			}
		};
	}

	constructor () {
		super();

		this.label = '';
		this.max = 0;
		this.min = 0;
	}

	render () {
		return html`
			<div class="room-progress">
				<label for="room-progress">${this.min + 1} of ${this.max}: ${this.label ? this.label : html`<slot name="label"></slot>`}</label>
				<progress id="room-progress" max="${this.max}" value="${this.min + 1}"></progress>
			</div>
		`;
	}
};

defineCustomElement('x-room-progress', RoomProgress);
